
import {
  Component,
  Vue
} from 'vue-property-decorator'
import SearchService from '../services/search-service'
import Months from '@/data/months.json'
import DateHelper from '@/mixins/date-mixins'
@Component({
  name: 'ProductionOrderReport',
  components: {}
})

export default class ProductionOrderReport extends Vue {
    protected isBusy = false
    protected showComponent = false
    protected isLoader = false
    protected isResult = false
    protected orders: any = []
    protected years: any = []
    protected year: any = null
    protected currentYear = DateHelper.year()
    protected months: any = Months
    protected month: any = null

    public show () {
      this.showComponent = true
      this.setYears(2025)
      this.populateMonths()
    }

    protected hide () {
      this.clear()
      this.showComponent = false
    }

    protected hideTable () {
      this.orders = []
      this.isResult = false
    }

    protected setYears (startYear: number) {
      const years: any = []
      while (startYear <= this.currentYear) {
        years.unshift(startYear++)
      }
      this.years = years
    }

    protected populateMonths () {
      const currentYear = DateHelper.year()
      if (this.year === currentYear) this.months = Months
      else this.months = Months
    }

    formatNumber (value) {
      if (value === null || value === undefined || value === '') return ''
      return Number(value).toLocaleString()
    }

    protected runReport () {
      this.isResult = false
      this.isLoader = true
      SearchService.getProductionOrderReport(Number(this.year), Number(this.month)).then((response) => {
        this.isLoader = false
        this.isResult = true
        this.orders = response.data.map(order => ({
          ...order,
          max_rows: Math.max(1, order.materials.length, order.process.length, order.assignments.length),
          created_date: order.created_date.split('-').reverse().join('-'),
          process: order.process.map(p => ({
            ...p,
            start_date: p.start_date ? p.start_date.split('-').reverse().join('-') : '',
            end_date: p.end_date ? p.end_date.split('-').reverse().join('-') : ''
          }))
        }))
      })
    }

    public clear () {
      this.month = null
      this.year = null
      this.orders = []
      this.isResult = false
    }

    private reset (obj: any) {
      for (const key in obj) {
        obj[key] = null
      }
    }
}

